import { useRouter } from 'next/router';

import parsePathParamToInt from '../helpers/parsePathParamToInt';

/**
 * @returns "tripId" from the next/router parameter in URL.
 */
export default function useTripId(): number | undefined {
  const { query } = useRouter();
  return parsePathParamToInt(query.tripId) ?? undefined;
}
